import {FloatingPortal} from "@floating-ui/react";
import classNames from "classnames";

import type {ISearchComboboxDropdownProps} from "../types/ISearchComboboxDropdownProps";

import * as styles from "./SearchComboboxDropdown.module.css";

/**
 * Desktop suggestions panel. One listbox wraps the scroll area and the pinned footer, so
 * `aria-activedescendant` can point at the footer row too; the panel height comes from `useAnchoredPanel` through
 * `--search-combobox-panel-max-height` (at most ~70% of the viewport, the footer always visible).
 */
export const SearchComboboxDropdown = (props: ISearchComboboxDropdownProps) => {
    const {isOpen, panel, listboxProps, children, footer, className, dataTestId} = props;

    if (!isOpen) {
        return null;
    }

    const content = (
        <div
            ref={panel.setPanelElement}
            style={panel.panelStyle}
            className={classNames(styles.panel, !panel.isPositioned && styles.panelHidden, className)}
            data-testid={dataTestId}
        >
            <div {...listboxProps} className={styles.listbox}>
                <div className={styles.scrollArea}>{children}</div>
                {footer}
            </div>
        </div>
    );

    return panel.mode === "portal" ? <FloatingPortal>{content}</FloatingPortal> : content;
};
import {FloatingPortal} from "@floating-ui/react";
import classNames from "classnames";

import type {ISearchComboboxDropdownProps} from "../types/ISearchComboboxDropdownProps";

import * as styles from "./SearchComboboxDropdown.module.css";

/**
 * Desktop suggestions panel. One listbox wraps the scroll area and the pinned footer, so
 * `aria-activedescendant` can point at the footer row too; the panel height comes from `useAnchoredPanel` through
 * `--search-combobox-panel-max-height` (at most ~70% of the viewport, the footer always visible).
 */
export const SearchComboboxDropdown = (props: ISearchComboboxDropdownProps) => {
    const {isOpen, panel, listboxProps, children, footer, className, dataTestId} = props;

    if (!isOpen) {
        return null;
    }

    const content = (
        <div
            ref={panel.setPanelElement}
            style={panel.panelStyle}
            className={classNames(styles.panel, !panel.isPositioned && styles.panelHidden, className)}
            data-testid={dataTestId}
        >
            <div {...listboxProps} className={styles.listbox}>
                <div className={styles.scrollArea}>{children}</div>
                {footer}
            </div>
        </div>
    );

    return panel.mode === "portal" ? <FloatingPortal>{content}</FloatingPortal> : content;
};
